import { HeaderDropdownMenu } from '@components/tailwind/HeaderDropdownMenu';
import Element from '@features/cms/components/Element';

const HeaderLink = (props) => {
  const handleDropdownOpen = () => {};

  return (
    <>
      {props.children?.length > 0 ? (
        <HeaderDropdownMenu
          name={props.attributes.label}
          onDropdownOpen={handleDropdownOpen}
          className={props.navCenterItemsClasses}>
          <div className='tw:absolute tw:inset-x-0 tw:z-[999] tw:bg-white tw:font-body tw:text-black tw:shadow-md'>
            <div className='tw:mx-auto tw:flex tw:max-w-[820px] tw:gap-5 tw:py-5'>
              {props.children.map((c, i) => (
                <Element key={i} {...c} />
              ))}
            </div>
          </div>
        </HeaderDropdownMenu>
      ) : (
        <div>
          <Element {...props} elementType='link' className={props.navCenterItemsClasses} />
        </div>
      )}
    </>
  );
};

export default HeaderLink;
